const ITEM_TYPES = {
  GENERAL: 0,
  TICKET: 1,
  PACKAGE: 3,
  COMBINATION: 14,
};

export default ITEM_TYPES;
